'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
var CardColumnWrapper = require('./CardColumnWrapper.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Card column wrapper image wrap
 *
 * Helps to define an image column inside various cards
 *
 * @internal Used internally by [Anything]Card components.
 */
var CardColumnWrapperImageWrap = react.forwardRef(function (props, ref) {
  var styles = CardColumnWrapper.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref,
    __css: styles.imageWrap
  }, props));
});
CardColumnWrapperImageWrap.displayName = 'CardColumnWrapperImageWrap';
exports.CardColumnWrapperImageWrap = CardColumnWrapperImageWrap;